const getters = {
    authToken: state => {
        return state.auth.token !== null ? state.auth.token.token : null
    },

    refreshToken: state => {
        return state.auth.token !== null ? state.auth.token.refreshToken : null;
    },

    authUser: state => {
        return state.auth.user;
    },

    isUserAuthenticated: state => {
        return state.auth.token !== null;
    },

    isRefreshingToken: state => {
        return state.isRefreshingToken;
    },

    getAuthUserTimezone: (state) => {
        return state.auth?.user?.timezone;
    },
    lastAuthTimestamp: state => {
        return state.lastAuthTimestamp;
    },
    logoutLoading: state => {
        return state.logoutLoading;
    },
    userLoaded: state => {
        return state.userLoaded;
    }
};

export default getters;
